import React from 'react';
import './Attractions.css';

const Attractions = () => {
  return (
    <section className="py-5 bg-primary bg-gradient" id="attractions">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5 section-header">
            <span className="badge bg-white bg-opacity-20 text-black px-3 py-2 rounded-pill mb-3">
              🎯 Inside MastiShorts
            </span>
            <h2 className="display-5 fw-bold text-white mb-4">A Sneak Peek Into the Experience</h2>
            <p className="lead text-white mb-0 opacity-75">
              Discover what makes MastiShorts so fun, vibrant, and full of energy. Here's a glimpse of the real-time features, stylish interface, and exciting live moments captured right inside the app.
            </p>
          </div>
        </div>
        
        <div className="attractions-container">
          <div className="attractions-scroll">
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed1.jpg" className="img-fluid w-100" alt="For You" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-heart text-danger me-2"></i>
                      For You
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed2.jpg" className="img-fluid w-100" alt="Video Chat" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-video text-success me-2"></i>
                      Video Chat
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed3.jpg" className="img-fluid w-100" alt="Streaming" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-broadcast-tower text-warning me-2"></i>
                      Streaming
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed4.jpg" className="img-fluid w-100" alt="Multi Video" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-layer-group text-info me-2"></i>
                      Multi Video
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed5.jpg" className="img-fluid w-100" alt="Follow" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-user-plus text-primary me-2"></i>
                      Follow
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed6.jpg" className="img-fluid w-100" alt="Live Stream" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-broadcast-tower text-danger me-2"></i>
                      Live Stream
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            {/* Duplicate items for seamless loop */}
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed1.jpg" className="img-fluid w-100" alt="For You" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-heart text-danger me-2"></i>
                      For You
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed2.jpg" className="img-fluid w-100" alt="Video Chat" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-video text-success me-2"></i>
                      Video Chat
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed3.jpg" className="img-fluid w-100" alt="Streaming" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-broadcast-tower text-warning me-2"></i>
                      Streaming
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed4.jpg" className="img-fluid w-100" alt="Multi Video" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-layer-group text-info me-2"></i>
                      Multi Video
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed5.jpg" className="img-fluid w-100" alt="Follow" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-user-plus text-primary me-2"></i>
                      Follow
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="attraction-card">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg hover-lift">
                <div className="attraction-image">
                  <img src="/img/unnamed6.jpg" className="img-fluid w-100" alt="Live Stream" style={{ height: '500px', objectFit: 'cover' }} />
                </div>
                <div className="position-absolute bottom-0 start-0 w-100 attraction-overlay p-3">
                  <div className="attraction-badge bg-white bg-opacity-20 backdrop-blur rounded-3 p-2 text-center">
                    <h6 className="text-black fw-bold mb-0">
                      <i className="fas fa-broadcast-tower text-danger me-2"></i>
                      Live Stream
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row mt-5">
          <div className="col-lg-12 text-center">
            <a target='_blank' href='https://play.google.com/store/apps/details?id=com.mastiindia&pcampaignid=web_share' className="btn btn-light btn-lg px-5 py-3 rounded-pill fw-bold shadow cta-button">
              <i className="fas fa-play me-2"></i>
              Experience MastiShorts Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Attractions;
